import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import PlaylistAddIcon from '@atlaskit/icon-lab/core/playlist-add';
import { Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	heading: {
		id: 'ai-audio.playlist.up-next-empty.heading',
		defaultMessage: 'Nothing here yet',
		description: 'Heading shown when the up next section of the playlist is empty',
	},
	description: {
		id: 'ai-audio.playlist.up-next-empty.description',
		defaultMessage: 'Add from recommendations below or tap the add-to-playlist action on any page.',
		description: 'Description shown when the up next section is empty, explaining how to add items',
	},
});

const styles = cssMap({
	container: {
		paddingBlock: token('space.300'),
		paddingInline: token('space.200'),
	},
});

export const PlaylistUpNextEmptyView = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Flex
			xcss={styles.container}
			justifyContent="center"
			alignItems="center"
			direction="column"
			rowGap="space.150"
		>
			<Text size="medium" weight="semibold">
				{formatMessage(messages.heading)}
			</Text>
			<Flex alignItems="center" columnGap="space.200" direction="row">
				<PlaylistAddIcon label="" color="var(--ds-icon-subtle)" />
				<Text size="medium" color="color.text.subtlest" align="start">
					{formatMessage(messages.description)}
				</Text>
			</Flex>
		</Flex>
	);
};
